import Vue from 'vue'
import { Component } from 'vue-property-decorator';
import { mapGetters, mapMutations } from 'vuex'
import * as types from '@/store/types'
import * as accountTypes from '@account/store/types'
@Component({
    name: 'loginInfo',
    methods: {
        ...mapMutations({
            setShowSidebar: types.SIDEBAR_VISIBLE
        })
    },
    computed: {
        ...mapGetters({
            user: accountTypes.USER
        })
    }
})
export default class LoginInfo extends Vue {
    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: G E T T E R S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //

    user!: account.User
    
    //
    // ────────────────────────────────────────────────────────── I ──────────
    //   :::::: M U T A T I O N S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────────
    //

    setShowSidebar!: (show: boolean) => void

    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: M E T H O D S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //

    closeSidebar() {
        this.setShowSidebar(false)
    }
}